import { Injectable } from '@angular/core';
import { FormBase, TextBox } from '@mapfre-design-library/src/public_api';

@Injectable({
  providedIn: 'root',
})
export class CreateNewPasswordFormService {
  getInputs(changePasswordType?) {
    let labelPwd = '';
    if (changePasswordType) {
      labelPwd = 'CREATE_PASSWORD';
    } else {
      labelPwd = 'PASSWORD';
    }
    const inputs: FormBase<any>[] = [
      new TextBox({
        additionalClasses: 'form-control',
        inputType: 'password',
        key: 'createPassword',
        label: labelPwd,
        minLength: 7,
        required: true,
        showPasswordIcon: true,
        type: 'password',
        validationMessageError: 'VALID_PASSWORD_VALIDATION_MESSAGE',
      }),
    ];
    return inputs;
  }
}
